import {GetterTree, MutationTree, Module, ActionTree} from 'vuex'
import {RootState, AuthState} from '../types'
import router from '@/router'
import {apiUrl, externalApiUrl, externalApiKey} from '@/config/service'
import axios from 'axios'

type AuthGetter = GetterTree<AuthState, RootState>

const state: AuthState = {
  me: null,
  token: null
}

export const getters: AuthGetter = {
  // With 3 parameters, you access the root state
  meGetter: (state) => state.me,
  tokenGetter: (state) => state.token
}

export const actions: ActionTree<AuthState, RootState> = {
  async loginAction({commit}, {formParams, queryParams}) {
    const {data} = await axios.post(`${apiUrl}/auth/login`, formParams)
    commit('loginMutation', data)
    return data
  },
  async updatePasswordAction({commit}, {formParams, queryParams}) {
    const {data} = await axios.post(`${apiUrl}/auth/updatePassword`, formParams)
    commit('updatePasswordMutation', data)
    return data
  },
  async logoutAction({commit}) {
    commit('logoutMutation')
  },
  async meAction({commit}) {
    const {data} = await axios.get(`${apiUrl}/user/me`)
    commit('meMutation', data)
    return data
  },
  async updateMeAction({commit}, {formParams}) {
    const {data} = await axios.post(`${apiUrl}/user/me`, formParams)
    commit('updateMeMutation', data)
    return data
  },
  async getUserByCleAccesParrainageAction({commit}, {cleAcces}) {
    try {
      const response = await axios.get(`${externalApiUrl}/auth/getUtilisateurByCleAccesParrainage.php`, {
        params: {cleAcces, externalApiKey}
      })
      return response
    } catch (err) {
      return err.response
    }
  }
}

const mutations: MutationTree<AuthState> = {
  async loginMutation(state, d) {
    state.token = d.token
    const {data} = await axios.get(`${apiUrl}/user/me`)
    state.me = data
    const {CODE_ROLE_CONSEILLER} = data
    if (CODE_ROLE_CONSEILLER === 'A' || CODE_ROLE_CONSEILLER === 'E') {
      router.replace('/')
    } else {
      router.replace('/mco')
    }
  },
  updatePasswordMutation(state, data) {
    console.log('update password')
  },
  logoutMutation(state) {
    state.token = null
    state.me = null
    router.replace('/auth/login')
  },
  meMutation(state, data) {
    state.me = data
  },
  updateMeMutation(state, data) {
    state.me = data
  }
}

export const auth: Module<AuthState, RootState> = {
  state,
  getters,
  actions,
  mutations,
  namespaced: true
}
